import { Button, CrossRegionPersistence } from "@brightagency/headstart-common";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import React, { FormEvent, useCallback, useEffect, useState } from "react";
import ReactGA4 from "react-ga4";
import { ANALYTICS_IDS } from "../../../../constants/analytics";
import { GlobalRegionMapping } from "../../../../constants/types";
import { useRegionsNewMappings, useSuburbSelectModalData } from "../../../../services/app-state";
import { useAssessmentState } from "../../../../services/assessment-state";
import { RichText } from "../../../atoms/RichText";
import { Location, SuburbSearch } from "../SuburbSearch";
import {
    Inner,
    Outer,
    Title,
    SubTitle,
    Header,
    InnerInner,
    NoMatchError,
    CheckboxLabel,
    FieldWrapper,
} from "./styled";

export const RegionSelect: React.FC = () => {
    const { setState } = useAssessmentState();
    const [isRememberingLocation, setIsRememberingLocation] = useState(true);
    const [selectedLocation, setSelectedLocation] = useState<Location | undefined>();
    const regionsNewMapping = useRegionsNewMappings();
    const [showNoMatchError, setShowNoMatchError] = useState(false);
    const [matchingRegion, setMatchingRegion] = useState<GlobalRegionMapping | undefined>();
    const [{ title, description, not_available_error }] = useSuburbSelectModalData();

    useEffect(() => {
        if (!selectedLocation) {
            return;
        }

        const matchingRegion = regionsNewMapping?.find((r: { postcodes: string; }) => {
            const postcodes = r.postcodes.split(",").map((p: string) => parseInt(p, 10));
            return postcodes.includes(selectedLocation?.postcode ?? -1);
        });

        setMatchingRegion(matchingRegion);

        if (matchingRegion) {
            setShowNoMatchError(false);
        } else {
            setShowNoMatchError(true);
        }
    }, [regionsNewMapping, selectedLocation]);

    const handleContinueClick = useCallback(
        (event: FormEvent) => {
            event.stopPropagation();
            event.preventDefault();
            if (!selectedLocation || !matchingRegion) return;
        
            CrossRegionPersistence.setChosenSuburb({
                ...selectedLocation,
                // regionUrl: matchingRegion.url,
                regionUrl: '/',
                regionname: matchingRegion.name,
                regionblurb: matchingRegion.region_blurb,
                region_logo: matchingRegion.region_logo.url,
                notification_bar_enabled: matchingRegion.notification_bar.enabled,
                notification_bar_content: matchingRegion.notification_bar.content,
                remembered: isRememberingLocation,
            });

            const setsuburb =  `${selectedLocation.name} ${selectedLocation.state} ${selectedLocation.postcode}`;
            const suburbname = selectedLocation.name ;
            setState({
                suburb: setsuburb,
                newsuburbname: suburbname,
                showselection:0,
            });

            ReactGA4.event({
                category: ANALYTICS_IDS.regionSet,
                action: ANALYTICS_IDS.regionSet + '.' + matchingRegion.name.split(' ').join('_'),
                label: matchingRegion.name,
            });

            window.location.reload();
        },
        [isRememberingLocation, matchingRegion, selectedLocation, setState],
    );

    return (
        <Outer>
            <Inner>
                <form>
                    <InnerInner>
                        <Header>
                            <Title>{title}</Title>
                            <SubTitle>
                                <RichText content={description} />
                            </SubTitle>

                            <FieldWrapper>
                                <SuburbSearch onLocationSelect={setSelectedLocation} />

                                <Button
                                    className = "popup-button"
                                    type="submit"
                                    disabled={selectedLocation == null || showNoMatchError}
                                    appearance="secondary"
                                    onClick={handleContinueClick}
                                    style={{ height: 60 }}
                                >
                                    Set suburb
                                </Button>
                            </FieldWrapper>
                            {showNoMatchError && (
                                <NoMatchError>
                                    <ErrorOutlinedIcon />
                                    {not_available_error}
                                </NoMatchError>
                            )}
                            <CheckboxLabel>
                                <input
                                    type="checkbox"
                                    checked={isRememberingLocation}
                                    onChange={e => {
                                        setIsRememberingLocation(e.target.checked);
                                    }}
                                />
                                Remember my selection on this device
                            </CheckboxLabel>
                        </Header>
                    </InnerInner>
                </form>
            </Inner>
        </Outer>
    );
};
